import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import { t } from "../app/Translate";
import Footer from "../components/Footer";
import { motion } from "framer-motion";


import opcion1 from '../svg/q_M-FACT-CY.svg';
import opcion2 from '../svg/01_M-INV-CW.svg';
import opcion3 from '../svg/01_M-TES-CW.svg';
import opcion4 from '../svg/01_M-CONT-CW.svg';
import opcion5 from '../svg/01_M-INFOR-CW.svg';
import opcion6 from '../svg/01_M-Avanzados-CW.svg';

import svg1 from '../svg/F-Bene1-CP.svg';
import svg2 from '../svg/F-Bene2-CP.svg';
import svg3 from '../svg/F-Bene3-CP.svg';
import svg4 from '../svg/F-Bene4-CP.svg';

const Invoices = () => {     
    const {isocode}: any = useParams();    
    const navigate = useNavigate();
    
    function NavigateTo(){
        let urlRegister = "/" + isocode + "/plans/" 
        navigate(urlRegister);
    }

    function NavigateToNew(idRuta: string){
        let urlRegister = "/" + isocode + "/" + idRuta + "/" 
        navigate(urlRegister);
    }

    return(
        <>
            <Header isocode={isocode} active="functions"/>
            <main className="main-content">
                <section className="header-invoices" style={{paddingLeft:"10%"}}>
                    <div className="row" style={{paddingTop:"130px",textAlign:"left"}}>
                        <div className="col-md-6 bannertext1">
                            {t("invoices.title")}
                            <div className="bannertext2" style={{paddingRight:"50px"}}>
                                {t("invoices.subtitle")}
                            </div>                            
                        </div>                        
                        <div className="col-md-6"></div>
                    </div>         
                    <br/><br/>
                </section>

                <section className=".iconsmenuadv onlydesktop" style={{backgroundColor:"#282C40"}}>
                    <div className="row" style={{paddingLeft:"140px", paddingRight:"140px", paddingBottom:"20px"}}>
                        <div className="col-md-2">
                            <img src={opcion1} className="iconmenuadv"/>
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#F2A007"}}>{t("menu.functions-invoices")}</span>
                        </div>
                        <div className="col-md-2" onClick={e => NavigateToNew("inventory")}>
                            <img src={opcion2} className="iconmenuadv" />
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.functions-inventory")}</span>
                        </div>
                        <div className="col-md-2" onClick={e => NavigateToNew("treasury")}>
                            <img src={opcion3} className="iconmenuadv" />
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.functions-treasury")}</span>
                        </div>
                        <div className="col-md-2" onClick={e => NavigateToNew("accounting")}>
                            <img src={opcion4} className="iconmenuadv" />
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.functions-gestion")}</span>
                        </div>
                        <div className="col-md-2" onClick={e => NavigateToNew("statements")}>
                            <img src={opcion5} className="iconmenuadv" />
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.functions-informs")}</span>
                        </div>
                        <div className="col-md-2" onClick={e => NavigateToNew("advanced")}>
                            <img src={opcion6} className="iconmenuadv" />
                            <br/>
                            <span className="iconmenuadvtitle" style={{color:"#ffffff"}}>{t("menu.advantage")}</span>
                        </div>
                    </div>
                </section>

                <section className="padingtag" style={{width:"100%",padding:"25px",backgroundColor:"#F0f1f2"}}>
                    <span style={{fontSize:"20px",color:"#282C40",lineHeight:"20px",fontWeight:"200"}}>{t("invoices.tag")}</span>
                </section>


                <section className="main-section padmakos" style={{backgroundColor:"#ffffff", textAlign:"left"}}>                    
                    <div className="row">         
                        <div className="col-md-1"></div>               
                        <div className="col-md-5">
                            <h2 className="whymakos-title" style={{color:"#282C40", paddingLeft:"0px", paddingRight:"0px"}}>{t("invoices.why")}</h2>
                            <motion.img
                                src="../../images/M-Facturacion.png"
                                style={{width:"80%"}}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-5" style={{textAlign:"left"}}>                            
                            <div className="title-section1" style={{color:"#4946A6",fontSize:"20px",lineHeight:"25px"}}>
                                {t("invoices.answer1")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40",fontSize:"21px", paddingTop:"15px", paddingBottom:"35px"}}>
                                {t("invoices.answer1det")}
                            </div> 

                            <div className="title-section1" style={{color:"#4946A6",fontSize:"20px",lineHeight:"25px"}}>
                                {t("invoices.answer2")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40",fontSize:"20px", paddingTop:"15px", paddingBottom:"40px"}}>
                                {t("invoices.answer2det")}
                            </div>

                            <div className="title-section1" style={{color:"#4946A6",fontSize:"20px",lineHeight:"25px"}}>
                                {t("invoices.answer3")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40",fontSize:"20px", paddingTop:"15px", paddingBottom:"40px"}}>
                                {t("invoices.answer3det")}
                            </div>                            
                        </div>                                         
                        <div className="col-md-1"></div>                  
                    </div>
                </section>
                
                <section className="main-section padmakos" style={{backgroundColor:"#282C40", textAlign:"left"}}>                    
                    <div className="row">                        
                        <div className="col-md-12">
                            <div className="reviewcard">
                                <div className="row">
                                    <div className="col-md-6">
                                        <img className="reviewLogo" src="/images/logoreview01.png" /> 
                                        <div className="reviewbody">
                                            {t("reviews.review1")}
                                        </div>               
                                        <hr className="divider-separator3" />
                                        <div className="reviewfootercustomer">
                                            <p>{t("reviews.review1customer")}</p>
                                        </div>
                                        <div className="reviewfooterlocal">
                                            <p>{t("reviews.review1local")}</p>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <img src="/images/review01.png" className="reviewImg" /> 
                                    </div>
                                </div>
                                
                            </div>
                        </div>                        
                    </div>
                </section>        

                <section className="main-section2 padmakos">
                    <div className="row">      
                        <div className="col-md-1"></div>    
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/CtasxCobrar3.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>              
                        <div className="col-md-5">
                            <div className="IconSection">
                                <img src={svg1} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("invoices.benef1title")}
                            </div>
                            <div className="body-section1" dangerouslySetInnerHTML={{ __html: t("invoices.benef1subtitle") }} />                             
                        </div>                                                                    
                        <div className="col-md-1"></div>    
                    </div>
                </section>
                
                <section className="main-section2 padmakos">
                    <div className="row">                   
                        <div className="col-md-1"></div>                                 
                        <div className="col-md-5">
                            <div className="IconSection">
                                <img src={svg2} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("invoices.benef2title")}
                            </div>
                            <div className="body-section1" dangerouslySetInnerHTML={{ __html: t("invoices.benef2subtitle") }} />                             
                        </div>                     
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Cotizaciones-v1.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>                              
                        <div className="col-md-1"></div>                     
                    </div>
                </section>
    
                <section className="main-section2 padmakos">
                    <div className="row">      
                        <div className="col-md-1"></div>        
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Facturar-2.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>              
                        <div className="col-md-5">
                            <div className="IconSection">
                                <img src={svg3} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("invoices.benef3title")}
                            </div>
                            <div className="body-section1" dangerouslySetInnerHTML={{ __html: t("invoices.benef3subtitle") }} />                             
                        </div>                                                                    
                        <div className="col-md-1"></div>    
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="row">                 
                        <div className="col-md-1"></div>                                   
                        <div className="col-md-5">
                            <div className="IconSection">
                                <img src={svg4} alt="icon"/>
                            </div>
                            <div className="title-section1">
                                {t("invoices.benef4title")}
                            </div>
                            <div className="body-section1" dangerouslySetInnerHTML={{ __html: t("invoices.benef4subtitle") }} />                             
                        </div>                     
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Facturacion-Cierre-2.png"
                                className="img-section1"
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>       
                        <div className="col-md-1"></div>                                            
                    </div>
                </section>

                <section className="main-section2 padmakos">
                    <div className="bordercolors" style={{marginTop:"40px",marginBottom:"80px"}}>
                        <div className="bordercolorsbody">
                            <div className="row" style={{padding:"10px"}}>
                                <div className="col-md-1"></div>
                                <div className="col-md-6">
                                    <div className="cta-question" style={{color:"#282C40"}}>{t("invoices.ctatitle")}</div>
                                    <div className="cta-message" style={{color:"#282C40"}}>{t("invoices.ctasubtitle")}</div>
                                </div>
                                <div className="col-md-4" style={{flexDirection:"column",display:"flex",paddingBottom:"70px", width:"100%"}}>                                                                        
                                     <center>                                    
                                        <button onClick={NavigateTo} className="animated-button" style={{width:"100%",marginTop:"10px"}}>{t("main.ctabutton")}</button>                                                                            
                                    </center>                                        
                                </div>
                                <div className="col-md-1"></div>
                            </div>                                                                     
                        </div>
                    </div>
                </section>                

                <Footer isocode={isocode} />  
            </main>
        </>
    )
}

export default Invoices;